// Components
import MemberNavbar from "../../Components/Member/Components/MemberNavbar";
import Sidebar from "../../Components/Member/Dashboard/Components/Sidebar";

import HomePage from "../../Components/Member/Dashboard/Sections/HomePage";
import Expenses from "../../Components/Member/Dashboard/Sections/Expenses";
import Revenue from "../../Components/Member/Dashboard/Sections/Revenue";

// Other
import React from "react";
import { useParams } from "react-router-dom";

const Dashboard = () => {
  const { page } = useParams();
  const activePage = page || "home";
  return (
    <>
      <MemberNavbar />
      <dashboard className="font-brand w-[98%] h-main flex desktop:mt-12">
        <Sidebar />

        {/* Render active page */}
        {activePage === "home" && <HomePage />}
        {activePage === "expenses" && <Expenses />}
        {activePage === "revenue" && <Revenue />}
      </dashboard>
    </>
  );
};

export default Dashboard;
